import React from "react";

const activeVariantClasses = {
  primary: "bg-primary text-white hover:bg-blue-700",
  secondary: "border border-primary text-primary hover:bg-blue-50",
  tertiary: "bg-neutral-200 text-gray-900",
  error: "bg-danger text-white hover:bg-red-700",
  success: "bg-success text-white hover:bg-green-700",
  link: "bg-white text-[#1C64F2]",
};

const disabledVariantClasses = {
  primary: "bg-gray-300 text-white cursor-not-allowed",
  secondary: "bg-white border border-gray-300 text-gray-400 cursor-not-allowed",
  tertiary: "bg-gray-200 text-gray-400 cursor-not-allowed",
  error: "bg-red-300 text-white cursor-not-allowed",
  success: "bg-green-300 text-white cursor-not-allowed",
  link: "bg-white text-gray-500 cursor-not-allowed"
};

const Button = ({
  variant = "primary",
  disabled = false,
  isLoading = false,
  showContentWhileLoading = true,
  children,
  className = "",
  startIcon,
  endIcon,
  ...props
}) => {
  const baseClass =
    "inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all justify-center";
  const variantClass =
    disabled || isLoading
      ? disabledVariantClasses[variant]
      : activeVariantClasses[variant];

  const allClasses = `${baseClass} ${variantClass} ${className}`.trim();

  const spinner = (
    <svg
      className="animate-spin h-4 w-4 text-current"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
      />
    </svg>
  );

  return (
    <button disabled={disabled || isLoading} className={allClasses} {...props}>
      {isLoading && <span>{spinner}</span>}
      {showContentWhileLoading ? (
        <>
          {!isLoading && startIcon && (
            <img src={startIcon} alt="start icon" className="h-6 w-6" />
          )}
          {!isLoading && <span>{children}</span>}
          {!isLoading && endIcon && (
            <img src={endIcon} alt="end icon" className="h-6 w-6" />
          )}
        </>
      ) : (
        !isLoading && (
          <>
            {startIcon && (
              <img src={startIcon} alt="start icon" className="h-6 w-6" />
            )}
            <span>{children}</span>
            {endIcon && (
              <img src={endIcon} alt="end icon" className="h-6 w-6" />
            )}
          </>
        )
      )}
    </button>
  );
};

export default Button;
